import { VertexBuffer } from '../mesh';

export class FullscreenQuad {
  buffer: VertexBuffer;
  vao: WebGLVertexArrayObject;

  constructor(gl: WebGL2RenderingContext) {
    const vertices = new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]);

    const glBuffer = gl.createBuffer()!;
    gl.bindBuffer(gl.ARRAY_BUFFER, glBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);

    this.buffer = new VertexBuffer(glBuffer, gl.TRIANGLES, 2, 6);

    this.vao = gl.createVertexArray()!;
    gl.bindVertexArray(this.vao);
    gl.bindBuffer(gl.ARRAY_BUFFER, glBuffer);
    gl.enableVertexAttribArray(0);
    gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
    gl.bindVertexArray(null);
  }

  draw(gl: WebGL2RenderingContext): void {
    gl.bindVertexArray(this.vao);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }

  destroy(gl: WebGL2RenderingContext): void {
    gl.deleteBuffer(this.buffer.glVertexBuffer);
    gl.deleteVertexArray(this.vao);
  }
}
